import { createAction, props } from '@ngrx/store';
import { FilterModel } from '../../models/filter-model';

export const setFilter = createAction(
  '[Filter] Set Filter',
  props<{ filter: FilterModel }>()
);

export const selectFilter = createAction(
  '[Filter] Select Filter'
  
);
